import { ReactElement, Suspense } from "react";
import { RouterProvider } from "react-router";

import AnnouncementBanner from "components/AnnouncementBanner";
import UpperRightToastContainer from "components/Toast/UpperRightToastContainer";
import router from "router/browserRouter";

/**
 * The top-level component
 */
export default function App(): ReactElement {
  return (
    <div className="App">
      <Suspense fallback={<div />}>
        <AnnouncementBanner />
        <UpperRightToastContainer />
        <RouterProvider router={router} />
      </Suspense>
    </div>
  );
}
